/*=========================================================================================
  File Name: moduleAdminMutations.js
  Description: Report Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import i18n from "@/i18n/i18n.js"

export default {

    SET_FILE_DOWNLOAD_COUNT_REPORT(state, data) {
        let series = [{
            name: i18n.t('FILE_DOWNLOAD_COUNTS'),
            data: [data.january, data.february, data.march, data.april, data.may, data.june, data.july, data.august, data.september, data.october, data.november, data.december]
        }]
        state.fileDownloadCountReportSeries = series
    },

    SET_FILE_STATISTICS(state, data) {
        state.countOfUploadedFile = data.countOfUploadedFile
        state.countOfNotUploadedFile = data.countOfNotUploadedFile
        state.sumOfSUsedStorage = data.sumOfSUsedStorage
    },

    SET_STREAMING_DURATION_REPORT(state, data) {
        let series = [{
            name: i18n.t('STREAMING_TIME'),
            data: [data.january, data.february, data.march, data.april, data.may, data.june, data.july, data.august, data.september, data.october, data.november, data.december]
        }]
        state.streamingDurationReportSeries = series
    },

    SET_STREAMING_DURATION_TABLE(state, data) {
        state.streamingDurationReportList = data.resultBody
        state.streamingDurationReportCount = data.resultCount
    },

    SET_SUBSCRIPTION_REPORT(state, data) {
        let purchase = data[0]
        let renew = data[1]
        let cancel = data[2]

        let series = [{
            name: i18n.t('SUBSCRIPTION_PURCHASE'),
            data: [purchase.january, purchase.february, purchase.march, purchase.april, purchase.may, purchase.june, purchase.july, purchase.august, purchase.september, purchase.october, purchase.november, purchase.december]
        }, {
            name: i18n.t('SUBSCRIPTION_RENEWED'),
            data: [renew.january, renew.february, renew.march, renew.april, renew.may, renew.june, renew.july, renew.august, renew.september, renew.october, renew.november, renew.december]
        }, {
            name: i18n.t('SUBSCRIPTION_CANCLE'),
            data: [cancel.january, cancel.february, cancel.march, cancel.april, cancel.may, cancel.june, cancel.july, cancel.august, cancel.september, cancel.october, cancel.november, cancel.december]
        }]

        state.subscriptionReportSeries = series
    },

    SET_SUBSCRIPTION_STATISTICS(state, data) {
        state.countOfSubscriptionPurchase = data.countOfSubscriptionPurchase
        state.countOfSubscriptionRenewed = data.countOfSubscriptionRenewed
        state.countOfSubscriptionCanceled = data.countOfSubscriptionCanceled
    },

    SET_S3_USAGE_REPORT(state, data) {
        let series = [{
            name: i18n.t('USAGE'),
            data: [data.january, data.february, data.march, data.april, data.may, data.june, data.july, data.august, data.september, data.october, data.november, data.december]
        }]
        state.s3UsageReportSeries = series
    },

    SET_WOWZA_USAGE_REPORT(state, data) {
        let series = [{
            name: i18n.t('USAGE'),
            data: [data.january, data.february, data.march, data.april, data.may, data.june, data.july, data.august, data.september, data.october, data.november, data.december]
        }]
        state.wowzaUsageReportSeries = series
    },




}
""